import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { Container } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { auth, firestore } from "../../firebase";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import {
  IconButton,
  MenuIcon,
  Box,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.primary,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '25ch',
  },
  form: {
    flexWrap: 'wrap',

  },
  margin: {
    marginTop: theme.spacing(2),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
}));

export default function AdminPage(props) {
  const classes = useStyles();
  const history = useHistory();
  const [name, setName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [desc, setDesc] = useState('');
  const [location, setLocation] = useState('');
  const [email, setEmail] = useState('');

  function handleSubmit(event) {
    event.preventDefault();
    if(!validateEmail(email)) {
      props.openSnackbar("Please enter valid email address.");
      return;
    }
    if (!(mobileNumber.length === 10 && name.length > 2)) {
      props.openSnackbar("Name and Mobile number is required.");
      return;
    }
    const currentUser = auth.currentUser;
    // console.log( 'name:', name, 'mobileNumber: ', mobileNumber); 
    const date = new Date();

    let collectionRef = firestore.collection('Managers');
    collectionRef.where('email', '==', email).get().then(querySnapshot => {
      if (querySnapshot.size === 0) {
        collectionRef.add({
          name: name,
          mobileNumber: mobileNumber,
          description: desc,
          location: location,
          rewards: 0,
          createdDate: date.toString(),
          createdByUserId: currentUser.uid,
          email: email,
          timestamp: new Date(),
        })
          .then(ref => {
           // alert("Saved Successfully.")
            props.openSnackbar("Saved Successfully.");
            setName("");
            setMobileNumber("");
            setDesc("");
            setLocation("");
            console.log("Added new party with ID: ", ref.id)
          });

      } else {
        //alert("Record already exist with same mobile number");
        props.openSnackbar("Record already exist with same email address.");
      }
    });
  }

  function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}


  return (
    <>
      <div className={classes.root}>
      <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper>
              <Box display="flex" flexGrow={1}>
                <IconButton onClick={() => { history.goBack()}} edge="end" color="inherit" aria-label="back">
                  <ArrowBackIosIcon />
                </IconButton>
                <Box flexGrow={1}>
                </Box>
                <Box flexGrow={1}>
                  <Typography className={classes.paper} variant="h6" component="h4">
                  Add New Party
                  </Typography>
                </Box>
                <Box flexGrow={1}>
                </Box>
                <IconButton edge="start" color="inherit" aria-label="back">
                  <ArrowBackIosIcon htmlColor="white" />
                </IconButton>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </div>
      <Container>
        <div className={classes.form}>
          <form noValidate autoComplete="off" >
            <TextField
              required
              id="filled-required"
              label="Name"
              placeholder="Name"
              variant="filled"
              fullWidth
              margin="normal"
              value={name}
              onInput={e => setName(e.target.value)}
            />
            <TextField
              required
              id="filled-number"
              label="Mobile Number"
              type="number"
              onInput={(e) => {
                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 10);
                setMobileNumber(e.target.value);
              }}
              placeholder="9723622285"
              variant="filled"
              fullWidth
              margin="normal"
              value={mobileNumber}
            />
              <TextField
              required
              id="filled-email"
              label="Email Address"
              type="email"
              onInput={(e) => {
                setEmail(e.target.value);
              }}
              placeholder="email@gmail.com"
              variant="filled"
              fullWidth
              errorText="Please enter valid email."
              margin="normal"
              value={email}
            />
            <TextField
              id="filled-required1"
              label="Description"
              placeholder="Description"
              variant="filled"
              fullWidth
              margin="normal"
              value={desc}
              onInput={e => setDesc(e.target.value)}
            />
            <TextField

              id="filled-required2"
              label="Location"
              placeholder="Location"
              variant="filled"
              fullWidth
              margin="normal"
              value={location}
              onInput={e => setLocation(e.target.value)}
            />
          </form>
        </div>

        <div className={classes.margin}>
          <Button variant="contained" size="large" fullWidth color="primary" onClick={handleSubmit}>
            Save
          </Button>
        </div>
      </Container>
    </>
  );
}
